export const ADMISSION_CREATE_REQUEST = "ADMISSION_CREATE_REQUEST";
export const ADMISSION_CREATE_SUCCESS = "ADMISSION_CREATE_SUCCESS";
export const ADMISSION_CREATE_FAIL = "ADMISSION_CREATE_FAIL";

export const ADMISSION_GET_ALL_REQUEST = "ADMISSION_GET_ALL_REQUEST";
export const ADMISSION_GET_ALL_SUCCESS = "ADMISSION_GET_ALL_SUCCESS";
export const ADMISSION_GET_ALL_FAIL = "ADMISSION_GET_ALL_FAIL";

export const ADMISSION_GET_ONE_REQUEST = "ADMISSION_GET_ONE_REQUEST";
export const ADMISSION_GET_ONE_SUCCESS = "ADMISSION_GET_ONE_SUCCESS";
export const ADMISSION_GET_ONE_FAIL = "ADMISSION_GET_ONE_FAIL";

export const ADMISSION_UPDATE_REQUEST = "ADMISSION_UPDATE_REQUEST";
export const ADMISSION_UPDATE_SUCCESS = "ADMISSION_UPDATE_SUCCESS";
export const ADMISSION_UPDATE_FAIL = "ADMISSION_UPDATE_FAIL";

export const ADMISSION_DELETE_REQUEST = "ADMISSION_DELETE_REQUEST";
export const ADMISSION_DELETE_SUCCESS = "ADMISSION_DELETE_SUCCESS";
export const ADMISSION_DELETE_FAIL = "ADMISSION_DELETE_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
